import { Icon, Modal } from "antd";
import React, { Fragment, useState } from "react";
import classNames from "classnames";
import { getFilenameFromUrl } from "../../../../../../helpers/functions";
import ImageViewer from "../../ImageViewer";
import VideoImageViewer from "../../VideoImageViewer";

const propTypes = {};
const imageType = ["jpeg", "jpg", "png"];
const PreviewButtonImg = ({
  multiple = false,
  onClickImage = (thumb, index) => {},
  onSelectFile = () => {},
  thumbnails,
  index,
  isPreview3x3 = false,
}) => {
  //! State
  const [activeShowIndex, setActiveShowIndex] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const thumbnailsImage = thumbnails.filter((el) => {
    const type = el.split(".")[el.split(".").length - 1];
    return imageType.includes(type);
  });

  
  //! Function
  const onClickPrev = () => {
    if(activeShowIndex === 0){
      setActiveShowIndex(thumbnails.length - 1);
    }else{
      setActiveShowIndex(activeShowIndex - 1);
    }
  };

  const onClickNext = () => {
    if(activeShowIndex === thumbnails.length - 1){
      setActiveShowIndex(0);
    }else{
      setActiveShowIndex(activeShowIndex + 1);
    }
  };

  const onClickThumbnail = (index) => {
    setActiveShowIndex(index);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onClickZoom =
    ({ index }) =>
    (e) => {
      e.stopPropagation();
      setOpen(true);
      setActiveShowIndex(index);
    };

  //! Render
  const renderViewer = () => {
    if (!isOpen) {
      return null;
    }

    if (thumbnailsImage.length === thumbnails.length) {
      return (
        <ImageViewer
          isPreview3x3={isPreview3x3}
          backdropCloseable={true}
          currImg={activeShowIndex}
          showThumbnails={thumbnails?.length > 1}
          isOpen={isOpen}
          onClose={onClose}
          onClickPrev={onClickPrev}
          onClickNext={onClickNext}
          onClickThumbnail={onClickThumbnail}
          imgs={thumbnails.map((src) => ({
            src,
            alt: getFilenameFromUrl(src),
          }))}
          thumbnails={thumbnails}
        />
      );
    }

    return (
      <VideoImageViewer
        isPreview3x3={isPreview3x3}
        backdropCloseable={true}
        currImg={activeShowIndex}
        showThumbnails={thumbnails?.length > 1}
        isOpen={isOpen}
        onClose={onClose}
        onClickPrev={onClickPrev}
        onClickNext={onClickNext}
        onClickThumbnail={onClickThumbnail}
        imgs={thumbnails.map((src) => ({ src, alt: getFilenameFromUrl(src) }))}
        thumbnails={thumbnails}
      />
    );
  };

  return (
    <Fragment>
      <div
        className={classNames({
          expandImage3x3: isPreview3x3,
          expandImageZoom: !isPreview3x3,
          cursorPointer: !!onClickImage || !multiple,
        })}
        onClick={multiple ? onClickImage : onSelectFile}
      >
        {isPreview3x3 && <span onClick={onClickZoom({ index })}>3 x 3</span>}
        {!isPreview3x3 && (
          <Icon type={"zoom-in"} onClick={onClickZoom({ index })} />
        )}
      </div>
        
      {renderViewer()}
    </Fragment>
  );
};

PreviewButtonImg.propTypes = propTypes;
export default React.memo(PreviewButtonImg);
